
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '../components/NewsItem.vue';
import { getNews } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  active = 12;
  tabs = [
    { id: 1, text: '成都', category: '成都' },
    { id: 2, text: '敦煌', category: '敦煌' },
    { id: 3, text: '杭州', category: '杭州' },
    { id: 4, text: '鹤壁', category: '鹤壁' },
    { id: 5, text: '合肥', category: '合肥' },
    { id: 6, text: '南京', category: '南京' },
    { id: 7, text: '宁波', category: '宁波' },
    { id: 8, text: '山东', category: '山东' },
    { id: 9, text: '苏州', category: '苏州' },
    { id: 10, text: '温州', category: '温州' },
    { id: 11, text: '厦门', category: '厦门' },
    { id: 12, text: '西安', category: '西安' },
    { id: 13, text: '重庆', category: '重庆' },
  ];
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  show = true;
  refreshing: boolean = false;
  titleText: string = '重庆';
  category: string = '重庆';

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  handleClickTab(index: number, cate: string, text: string) {
    this.active = index;
    this.category = cate;
    this.titleText = text;
    this.show = false;
    this.resetNewsList();
  }
  onLoad() {
    this.getNewsList();
  }

  async getNewsList() {
    getNews(this.page, this.category, '9226').then((res: any) => {
      this.endListData(res);
    });
  }

  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data.data || res.data.data.length === 0) {
      this.finished = true;
    } else {
      if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
      this.finished = true;
      } else {
        this.list = [...this.list, ...res.data.data[0].list];
      }
    }
    this.loading = false;
  }
  resetNewsList() {
    setTimeout( () => { this.show = true; }, 200);
    this.finished = false;
    this.list = [];
    this.page = 1;
  }
}
